// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ctables {
  border-collapse: collapse;
  width: 109%;
  margin: 0%;
  margin-top: 0%;
}

.red {
  color: red;
}

.blue {
  color: blue;
}

.urgent {
  color: #e65100;
  animation: urgentBlink 2s ease-in-out infinite;
}

tr.urgent {
  animation: urgentRowBlink 2s ease-in-out infinite;
}

@keyframes urgentBlink {
  0%,
  100% {
    color: #e65100;
  }
  50% {
    color: #ff3d00;
  }
}

@keyframes urgentRowBlink {
  0%,
  100% {
    background-color: rgba(255, 152, 0, 0.28);
  }
  50% {
    background-color: rgba(255, 152, 0, 0.05);
  }
}

.black {
  color: black;
}

.tdCu {
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 16px;
  border-bottom: 1px solid #efefef !important;
  padding: 10px 5px 10px 10px !important;
  text-align: left;
}

.Cth {
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 16px;
  border-bottom: 1px solid #efefef !important;
  padding: 14px 5px 14px 9px !important;
  text-align: left;
  /* background-color:#32c89614; */
}

th span,
td span {
  font-weight: normal;
}

/* .noOrders {
  color: red;
  padding-left: 20px;
  font-size: 15px;
  padding-top: 10px;
  width: 100%;
  text-align: center;
  vertical-align: middle;
  padding: 20px;
} */

.noOrders {
  height: 40vh; /* Full height of the viewport or adjust as needed */
  width: 100%;
  text-align: center;
  vertical-align: middle;
}

.full-width-container {
  display: table;
  width: 100vw; /* Full viewport width */
  height: 70vh; /* Optional: Full viewport height */
}

.full-width-container:hover {
  background: transparent !important;
  color: inherit !important;
  border: none !important;
  box-shadow: none !important;
  text-decoration: none !important;
  transform: none !important;
  opacity: 1 !important;
}

.less-full-width-container {
  /* display: table; */
  width: 100%; /* Full viewport width */
  height: 10vh; /* Optional: Full viewport height */
  margin-top: -100px;
  margin-bottom: -100px;
}

.lesser-full-width-container {
  display: table;
  width: 100%; /* Full viewport width */
  height: 50vh; /* Optional: Full viewport height */
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.noOrdersMsg {
  font-size: 20px;
  animation: fadeInUp 0.4s ease-in-out;
}

.center-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100px; /* Adjust as needed */
  width: 100%;
}

.icon-wrapper {
  background-color: #07a6ef;
  padding: 10px; /* This ensures space around the icon */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  margin-top: 15px;
  /* animation: bounce 1.5s infinite ease-in-out; */
  animation: fadeInUp 0.4s ease-in-out;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 18px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 14px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 10px;
  width: 10px;
  left: 4px;
  bottom: 4px;
  background-color: white;

  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #07a6ef;
}

.TotalCu {
  text-align: right;
  margin-top: -20px;
  font-size: 0.875rem;
  color: #64748b;
  font-weight: 600;
}

.orders-pagination-wrap {
  display: flex;
  justify-content: stretch;
  margin: 12px 16px 24px;
  padding: 10px 14px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

/* Floating bulk action toolbar */
.bulk-action-bar {
  position: fixed;
  top: 88px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1100;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px 8px 14px;
  background: #0f172a;
  color: #fff;
  border-radius: 999px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.28);
  max-width: calc(100vw - 24px);
}

.bulk-action-count {
  font-size: 0.8rem;
  font-weight: 650;
  white-space: nowrap;
  padding-right: 6px;
  border-right: 1px solid rgba(255, 255, 255, 0.18);
  margin-right: 2px;
}

.bulk-action-count strong {
  font-weight: 750;
  color: #7dd3fc;
}

.bulk-action-btns {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.bulk-action-btn {
  appearance: none;
  border: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 650;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.1);
  color: #f8fafc;
  transition: background 0.15s ease, color 0.15s ease;
}

.bulk-action-btn:hover {
  background: rgba(255, 255, 255, 0.18);
}

.bulk-action-btn svg {
  font-size: 1rem;
  width: 1rem;
  height: 1rem;
}

.bulk-action-btn.is-primary {
  background: #0ea5e9;
  color: #fff;
}

.bulk-action-btn.is-primary:hover {
  background: #0284c7;
}

.bulk-action-btn.is-danger {
  background: rgba(248, 113, 113, 0.18);
  color: #fecaca;
}

.bulk-action-btn.is-danger:hover {
  background: rgba(248, 113, 113, 0.3);
  color: #fff;
}

.bulk-action-clear {
  appearance: none;
  border: none;
  background: transparent;
  color: #94a3b8;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0 6px;
  margin-left: 2px;
}

.bulk-action-clear:hover {
  color: #e2e8f0;
}

@media (max-width: 720px) {
  .bulk-action-bar {
    top: auto;
    bottom: 18px;
    border-radius: 14px;
    flex-direction: column;
    align-items: stretch;
    padding: 10px 12px;
  }

  .bulk-action-count {
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    padding: 0 0 8px;
    margin: 0 0 6px;
  }

  .bulk-action-btns {
    justify-content: center;
  }
}

input:focus + .slider {
  box-shadow: 0 0 1px #07a6ef;
}

input:checked + .slider:before {
  transform: translateX(12px);
}

.assignD {
  border-radius: 5px;
  height: 27px;
  border: 1px solid lightgray;
  background-image: linear-gradient(to top, rgb(227, 226, 226), white);
  padding: 5px;
}

.assignD:hover {
  cursor: pointer;
}

.actions-dropdown {
  position: relative;
}

.dropdown {
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content li {
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content li:hover {
  background-color: #f1f1f1;
}

.Dbutton {
  border: 1px solid #f1f1f1;
  font-size: 20px;
  background-color: white;
  padding: 4px;
}

.Dbutton:hover {
  cursor: pointer;
}

.detailsD {
  border: 0px;
  background-color: white;
  text-decoration: underline;
}

.detailsD:hover {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Css/Current.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE;;IAEE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;;IAEE,yCAAyC;EAC3C;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,2CAA2C;EAC3C,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,2CAA2C;EAC3C,qCAAqC;EACrC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;;;;;;GASG;;AAEH;EACE,YAAY,EAAE,oDAAoD;EAClE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY,EAAE,wBAAwB;EACtC,YAAY,EAAE,mCAAmC;AACnD;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,WAAW,EAAE,wBAAwB;EACrC,YAAY,EAAE,mCAAmC;EACjD,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW,EAAE,wBAAwB;EACrC,YAAY,EAAE,mCAAmC;AACnD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,qBAAqB;EACpC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa,EAAE,uCAAuC;EACtD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iDAAiD;EACjD,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;;EAEvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;EACjD,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kDAAkD;IAClD,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,oEAAoE;EACpE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,2CAA2C;EAC3C,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".Ctables {\r\n  border-collapse: collapse;\r\n  width: 109%;\r\n  margin: 0%;\r\n  margin-top: 0%;\r\n}\r\n\r\n.red {\r\n  color: red;\r\n}\r\n\r\n.blue {\r\n  color: blue;\r\n}\r\n\r\n.urgent {\r\n  color: #e65100;\r\n  animation: urgentBlink 2s ease-in-out infinite;\r\n}\r\n\r\ntr.urgent {\r\n  animation: urgentRowBlink 2s ease-in-out infinite;\r\n}\r\n\r\n@keyframes urgentBlink {\r\n  0%,\r\n  100% {\r\n    color: #e65100;\r\n  }\r\n  50% {\r\n    color: #ff3d00;\r\n  }\r\n}\r\n\r\n@keyframes urgentRowBlink {\r\n  0%,\r\n  100% {\r\n    background-color: rgba(255, 152, 0, 0.28);\r\n  }\r\n  50% {\r\n    background-color: rgba(255, 152, 0, 0.05);\r\n  }\r\n}\r\n\r\n.black {\r\n  color: black;\r\n}\r\n\r\n.tdCu {\r\n  font-size: 14px !important;\r\n  font-weight: 500 !important;\r\n  line-height: 16px;\r\n  border-bottom: 1px solid #efefef !important;\r\n  padding: 10px 5px 10px 10px !important;\r\n  text-align: left;\r\n}\r\n\r\n.Cth {\r\n  font-size: 14px !important;\r\n  font-weight: 500 !important;\r\n  line-height: 16px;\r\n  border-bottom: 1px solid #efefef !important;\r\n  padding: 14px 5px 14px 9px !important;\r\n  text-align: left;\r\n  /* background-color:#32c89614; */\r\n}\r\n\r\nth span,\r\ntd span {\r\n  font-weight: normal;\r\n}\r\n\r\n/* .noOrders {\r\n  color: red;\r\n  padding-left: 20px;\r\n  font-size: 15px;\r\n  padding-top: 10px;\r\n  width: 100%;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  padding: 20px;\r\n} */\r\n\r\n.noOrders {\r\n  height: 40vh; /* Full height of the viewport or adjust as needed */\r\n  width: 100%;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n}\r\n\r\n.full-width-container {\r\n  display: table;\r\n  width: 100vw; /* Full viewport width */\r\n  height: 70vh; /* Optional: Full viewport height */\r\n}\r\n\r\n.full-width-container:hover {\r\n  background: transparent !important;\r\n  color: inherit !important;\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n  text-decoration: none !important;\r\n  transform: none !important;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.less-full-width-container {\r\n  /* display: table; */\r\n  width: 100%; /* Full viewport width */\r\n  height: 10vh; /* Optional: Full viewport height */\r\n  margin-top: -100px;\r\n  margin-bottom: -100px;\r\n}\r\n\r\n.lesser-full-width-container {\r\n  display: table;\r\n  width: 100%; /* Full viewport width */\r\n  height: 50vh; /* Optional: Full viewport height */\r\n}\r\n\r\n@keyframes fadeInUp {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes bounce {\r\n  0%,\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n  50% {\r\n    transform: translateY(-10px);\r\n  }\r\n}\r\n\r\n.noOrdersMsg {\r\n  font-size: 20px;\r\n  animation: fadeInUp 0.4s ease-in-out;\r\n}\r\n\r\n.center-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100px; /* Adjust as needed */\r\n  width: 100%;\r\n}\r\n\r\n.icon-wrapper {\r\n  background-color: #07a6ef;\r\n  padding: 10px; /* This ensures space around the icon */\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-bottom: 15px;\r\n  margin-top: 15px;\r\n  /* animation: bounce 1.5s infinite ease-in-out; */\r\n  animation: fadeInUp 0.4s ease-in-out;\r\n}\r\n\r\n.toggle-switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 30px;\r\n  height: 18px;\r\n}\r\n\r\n.toggle-switch input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: #ccc;\r\n  -webkit-transition: 0.4s;\r\n  transition: 0.4s;\r\n  border-radius: 14px;\r\n}\r\n\r\n.slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 10px;\r\n  width: 10px;\r\n  left: 4px;\r\n  bottom: 4px;\r\n  background-color: white;\r\n\r\n  transition: 0.4s;\r\n  border-radius: 50%;\r\n}\r\n\r\ninput:checked + .slider {\r\n  background-color: #07a6ef;\r\n}\r\n\r\n.TotalCu {\r\n  text-align: right;\r\n  margin-top: -20px;\r\n  font-size: 0.875rem;\r\n  color: #64748b;\r\n  font-weight: 600;\r\n}\r\n\r\n.orders-pagination-wrap {\r\n  display: flex;\r\n  justify-content: stretch;\r\n  margin: 12px 16px 24px;\r\n  padding: 10px 14px;\r\n  background: #fff;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n/* Floating bulk action toolbar */\r\n.bulk-action-bar {\r\n  position: fixed;\r\n  top: 88px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 1100;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 8px 10px 8px 14px;\r\n  background: #0f172a;\r\n  color: #fff;\r\n  border-radius: 999px;\r\n  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.28);\r\n  max-width: calc(100vw - 24px);\r\n}\r\n\r\n.bulk-action-count {\r\n  font-size: 0.8rem;\r\n  font-weight: 650;\r\n  white-space: nowrap;\r\n  padding-right: 6px;\r\n  border-right: 1px solid rgba(255, 255, 255, 0.18);\r\n  margin-right: 2px;\r\n}\r\n\r\n.bulk-action-count strong {\r\n  font-weight: 750;\r\n  color: #7dd3fc;\r\n}\r\n\r\n.bulk-action-btns {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.bulk-action-btn {\r\n  appearance: none;\r\n  border: none;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  height: 32px;\r\n  padding: 0 12px;\r\n  border-radius: 999px;\r\n  font-size: 0.78rem;\r\n  font-weight: 650;\r\n  cursor: pointer;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  color: #f8fafc;\r\n  transition: background 0.15s ease, color 0.15s ease;\r\n}\r\n\r\n.bulk-action-btn:hover {\r\n  background: rgba(255, 255, 255, 0.18);\r\n}\r\n\r\n.bulk-action-btn svg {\r\n  font-size: 1rem;\r\n  width: 1rem;\r\n  height: 1rem;\r\n}\r\n\r\n.bulk-action-btn.is-primary {\r\n  background: #0ea5e9;\r\n  color: #fff;\r\n}\r\n\r\n.bulk-action-btn.is-primary:hover {\r\n  background: #0284c7;\r\n}\r\n\r\n.bulk-action-btn.is-danger {\r\n  background: rgba(248, 113, 113, 0.18);\r\n  color: #fecaca;\r\n}\r\n\r\n.bulk-action-btn.is-danger:hover {\r\n  background: rgba(248, 113, 113, 0.3);\r\n  color: #fff;\r\n}\r\n\r\n.bulk-action-clear {\r\n  appearance: none;\r\n  border: none;\r\n  background: transparent;\r\n  color: #94a3b8;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  padding: 0 6px;\r\n  margin-left: 2px;\r\n}\r\n\r\n.bulk-action-clear:hover {\r\n  color: #e2e8f0;\r\n}\r\n\r\n@media (max-width: 720px) {\r\n  .bulk-action-bar {\r\n    top: auto;\r\n    bottom: 18px;\r\n    border-radius: 14px;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    padding: 10px 12px;\r\n  }\r\n\r\n  .bulk-action-count {\r\n    border-right: none;\r\n    border-bottom: 1px solid rgba(255, 255, 255, 0.12);\r\n    padding: 0 0 8px;\r\n    margin: 0 0 6px;\r\n  }\r\n\r\n  .bulk-action-btns {\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\ninput:focus + .slider {\r\n  box-shadow: 0 0 1px #07a6ef;\r\n}\r\n\r\ninput:checked + .slider:before {\r\n  -webkit-transform: translateX(5px);\r\n  -ms-transform: translateX(15px);\r\n  transform: translateX(12px);\r\n}\r\n\r\n.assignD {\r\n  border-radius: 5px;\r\n  height: 27px;\r\n  border: 1px solid lightgray;\r\n  background-image: linear-gradient(to top, rgb(227, 226, 226), white);\r\n  padding: 5px;\r\n}\r\n\r\n.assignD:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n.actions-dropdown {\r\n  position: relative;\r\n}\r\n\r\n.dropdown {\r\n  display: inline-block;\r\n  position: relative;\r\n  cursor: pointer;\r\n}\r\n\r\n.dropdown-content {\r\n  display: none;\r\n  position: absolute;\r\n  background-color: #f9f9f9;\r\n  min-width: 160px;\r\n  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\r\n  z-index: 1;\r\n}\r\n\r\n.dropdown-content li {\r\n  padding: 12px 16px;\r\n  text-decoration: none;\r\n  display: block;\r\n}\r\n\r\n.dropdown-content li:hover {\r\n  background-color: #f1f1f1;\r\n}\r\n\r\n.Dbutton {\r\n  border: 1px solid #f1f1f1;\r\n  font-size: 20px;\r\n  background-color: white;\r\n  padding: 4px;\r\n}\r\n\r\n.Dbutton:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n.detailsD {\r\n  border: 0px;\r\n  background-color: white;\r\n  text-decoration: underline;\r\n}\r\n\r\n.detailsD:hover {\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
